import {NgModelChangeDebouncedDirective} from "@app/directives/ng-model-change-debounced.directive";
import {NgModule} from "@angular/core";
import {DynamicDateInputDirective} from "@app/directives/dynamic-date-input.directive";
import {HasPermissionDirective} from "@app/directives/has-permission.directive";

@NgModule({
  declarations: [
    NgModelChangeDebouncedDirective,
    DynamicDateInputDirective,
    HasPermissionDirective
  ],
  exports: [
    NgModelChangeDebouncedDirective,
    DynamicDateInputDirective,
    HasPermissionDirective
  ]
})
export class DirectivesModule { }
